const styles = theme => ({
  form: {
    display: "flex",
    flexDirection: "column"
  },
  fields: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap"
  },
  field: {
    flex: "1 48%",
    minWidth: 250,
    "&:nth-of-type(odd)": {
      marginRight: "2%"
    },
    "&:last-of-type": {
      marginRight: 0
    },
    [theme.breakpoints.down("sm")]: {
      flex: "1 100%",
      marginRight: 0
    }
  },
  additionalInfoTitle: {
    color: theme.palette.primary.default
  },
  additionalInfoExplanation: {
    color: theme.palette.primary.default
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Register/components/AdditionalInfo/styles.js